import { eventBus, EVENTS } from '../commons/EventBus.js';
import { Paginator } from '../commons/paginator.js';
let interval;
let intervalInitiator = false;
eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;

    if(template!='home'&&template!='homepage'&&template!=''){
        return;
    }


    initPaginator();
    if(!intervalInitiator){
        sliderProgrammi();
    }

});


function sliderProgrammi(){

    var timerProgrammi = ()=>{
        if(interval){
            clearInterval(interval);
        }
        interval = setInterval(function(){

            $("#programmi-paginator").find(".paginator.selected").siblings(".paginator").first().trigger("click");

        }, 7000);
    };
    timerProgrammi();

    intervalInitiator = true;

    // $('#programmi-paginator').find(".paginator").not(".selected").click(function(){
    //     clearInterval(interval);
    //     timerProgrammi();
    // });

    // $("#programmi-paginator").find(".paginator").on('click', () => {
    //     clearInterval(interval);
    //     timerProgrammi();
    // });

    $(document).on("click", "#programmi-paginator .paginator", ()=>{
        clearInterval(interval);
        setTimeout(function(){
          timerProgrammi();
      }, 7000);

    })
}

function initPaginator(){
    const breakpoints = [

        { perPage: 1 }
    ];
    new Paginator($('#programmi-paginator'), {
        total: 2 ,
        breakpoints: breakpoints,
        cssVar: '--slider_home_paginator',
        swipeElementSelector: '#container_slider_programmi'
    });
}
